import React from "react";
import { useNavigate } from "react-router-dom";
// ✅ Ensure your AutocompleteInput is exported correctly
import AutocompleteInput from "../components/AutocompleteInput"; 
import "../css/SearchBar.css";

export default function SearchBar({ filters, setFilters }) {
  const navigate = useNavigate();

  // ✅ The logic is correct, but we'll ensure it's a clean object update
  const handleSwap = () => {
    if (!filters.from && !filters.to) return; // Don't swap empty fields
    setFilters((prev) => ({
      ...prev,
      from: prev.to,
      to: prev.from
    }));
  };

  const setFrom = (val) => {
    const text = typeof val === "string" ? val : val?.target?.value ?? "";
    setFilters((f) => ({ ...f, from: text }));
  };

  const setTo = (val) => {
    const text = typeof val === "string" ? val : val?.target?.value ?? "";
    setFilters((f) => ({ ...f, to: text }));
  };

  const handleSearch = () => {
    if (!filters.from || !filters.to) return alert("Please select both locations");
    
    // ✅ NEW: Save the search to browser memory!
    localStorage.setItem("vyango_search_from", filters.from);
    localStorage.setItem("vyango_search_to", filters.to);

    const query = new URLSearchParams({ ...filters, type: "flexible" }).toString();
    navigate(`/search?${query}`);
  };

  return (
    <section className="search-wrapper">
      <div className="search-bar-card">
        <h2 className="search-title">Find your ride</h2>
        <p className="search-subtitle">Search verified rides across cities and towns worldwide.</p>

        <div className="search-bar-grid">
          <div className="search-bar-row top-row">
            <div className="search-field">
              <label>From</label>
              <AutocompleteInput
                value={filters.from || ""} // ✅ Ensure this is controlled
                placeholder="Leaving from"
                onChange={setFrom}
              />
            </div>

            {/* ✅ Attractive Swap Button */}
            <button
              type="button"
              className="swap-button"
              onClick={handleSwap}
              aria-label="Swap Locations"
            >
              <span className="swap-icon">⇄</span>
            </button>

            <div className="search-field">
              <label>To</label>
              <AutocompleteInput
                value={filters.to || ""} // ✅ Ensure this is controlled
                placeholder="Going to"
                onChange={setTo}
              />
            </div>
          </div>

          <div className="search-bar-row bottom-row">
            <div className="search-field">
              <label>Date</label>
              <input
                type="date"
                className="input"
                value={filters.date}
                onChange={(e) => setFilters((f) => ({ ...f, date: e.target.value }))}
              />
            </div>

            <div className="search-field">
              <label>Passengers</label>
              <input
                type="number"
                min="1"
                className="input"
                value={filters.passengers}
                onChange={(e) => setFilters((f) => ({ ...f, passengers: e.target.value }))}
              />
            </div>

            <div className="search-action">
              <button type="button" className="btn-primary" onClick={handleSearch}>
                Search
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}